import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as TransactionActions from "../../store/transaction/actions";
import { IAccountSummary } from "../../store/transaction/types";
import { formatCurrency } from "../../util/credit";
import * as httpClient from "../../util/httpClient";
import { DialogComponent } from "../common/DialogComponent";
import TransactionEditAccountDialog from "../Dialogs/TransactionEditAccountDialog";
import TransactionAlertPreferenceDialog from "../Dialogs/TransactionAlertPreferenceDialog";
import AddAccountDialog from "./AddAccountDialog";
import { Notification } from "../common/Notification";
import * as services from "../../store/service";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ezsServiceIds, idfServiceIds, enableMXForIDF } from "../../config/UserServicesList";
import { useAreServicesActive } from "../../util/CommonServices";
import TransactionConfirmDeleteAccountDialog from "../Dialogs/TransactionConfirmDeleteAccountDialog";
import * as alertActions from "../../store/AlertsService/actions";
import * as UserServiceAction from "../../store/userService/actions";
import defaultImg from "../../Assets/images/default_institution_logo.png";
export default function TransactionsFinancialAccount() {
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const [addAccountIsVisible, setAddAccountDialogIsVisible] = useState(false);
    const [showTransactionEditAccountDialog, setShowTransactionEditAccountDialog] = useState(false);
    const [showTransactionAlertPrefDialog, setShowTransactionAlertPrefDialog] = useState(false);
    const [showTransactionDeleteAccountConfirmDialog, setShowTransactionDeleteAccountConfirmDialog] = useState(false);
    const requestAlertData = (reload: boolean) => dispatch(alertActions.actionCreators.getAlertData(isBusinessUser, reload));
    const requestUserServiceReload = (reloadData: boolean) => dispatch(UserServiceAction.actionCreators.requestUserService(reloadData));

    const [deleteMemberInfo, setDeleteMemberInfo] = useState({});
    const closeTransactionDeleteAccountConfirmDialog = () => {
        setShowTransactionDeleteAccountConfirmDialog(false);
    };
    const handleTransactionDeleteAccountConfirmDialog = (value: string, memberInfo: any): any => {
        if (value === "show") {
            setDeleteMemberInfo(memberInfo);
            setShowTransactionDeleteAccountConfirmDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowTransactionDeleteAccountConfirmDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowTransactionDeleteAccountConfirmDialog(false);
            requestAccountSummary();
            requestAlertData(true);
            sessionStorage.setItem('reloadUserServices', JSON.stringify(true));
        }
    };
    const [stateSummary, setStateSummary] = useState({
        "account-id": 0,
        "account-name": "",
        "account-nickname": "",
        "account-number": 0,
        "account-balance": 0,
        alerts: 0,
        transactions: 0,
        "account-type": "",
        "account-type-id": 0,
        "idf-monitor-id": "",
    });
    const yodleeServiceList = [idfServiceIds.bankAndCreditCardActivity, ezsServiceIds.financialTransactionMonitoring];
    const isYodleeTransactionServiceActive = useAreServicesActive(yodleeServiceList) && !enableMXForIDF;
    const isYodleeServiceEnabled = useAreServicesActive(yodleeServiceList) && enableMXForIDF;
    const mxServiceList = [ezsServiceIds.financialTransactionMonitoringMX];
    const ismxServiceActive = useAreServicesActive(mxServiceList) || isYodleeServiceEnabled;
    const [addAccountLink, setAddAccountLink] = useState("");
    const [dialogType, setDialogType] = useState("Add Account");
    const dispatch = useDispatch();
    const requestAccountSummary = () => dispatch(TransactionActions.actionCreators.requestAccountSummary());
    const requestMXAccountSummary = () => dispatch(TransactionActions.actionCreators.requestMXAccountSummary());
    const requestChartData = () => dispatch(TransactionActions.actionCreators.requestChartData());
    const requestRecentTransactions = (offset: number, limit: string, bankAccountTypeId: string, startDate: string, endDate: string, accountId: string) =>
        dispatch(TransactionActions.actionCreators.requestRecentTransactions(offset, limit, bankAccountTypeId, startDate, endDate, accountId));
    const ensureDataFetched = () => {
        requestAccountSummary();
    };
    const [isShowAddAccountDialog, setisShowAddAccountDialog] = useState(false);
    const isLoading = useSelector((state: ApplicationState) => {
        return state.accountSummaryData.isLoading;
    });
    const [isMXUserActive, setisMXUserActive] = useState(false);
    const [isLoadingUserStatus, setisLoadingUserStatus] = useState(false);
    const segregatedData: any = {};
    let segData: any;
    function segregateRecords(accounts: any) {
        accounts.forEach((account: any) => {
            const memberId = !!account.memberId ? account.memberId : account["idf-monitor-id"];
            const memberName = !!account.memberName ? account.memberName : account["account-name"];
            const logo = account.smallLogoUrl;
            // If member key doesn't exist, create an array for it
            if (!segregatedData[memberId]) {
                segregatedData[memberId] = { memberName, memberId, logo, accounts: [] };
            }

            // Add the account to the corresponding member's array
            segregatedData[memberId].accounts.push(account);
        });

        return Object.values(segregatedData);
    }

    const accountSummaryData = useSelector((state: ApplicationState) => {
        if (state.accountSummaryData.accountSummaryData == null || state.accountSummaryData.accountSummaryData.data == null) {
            return null;
        } else {
            segData = segregateRecords(state.accountSummaryData.accountSummaryData.data);
            state.accountSummaryData.accountSummaryData.data.forEach(function (summaryData) {
                summaryData["account-id"] = parseInt(summaryData["account-id"]?.toString());
                summaryData["account-number"] = parseInt(summaryData["account-number"]?.toString());
                summaryData["account-balance"] = parseFloat(summaryData["account-balance"]?.toString());
                summaryData["alerts"] = parseInt(summaryData["alerts"]?.toString());
                if (summaryData["account-type"] != null && summaryData["account-type"]?.startsWith("Debit")) {
                    summaryData["account-type"] = "Debit Cards";
                    summaryData.logo = "credit-card";
                } else if (summaryData["account-type"] != null && summaryData["account-type"]?.startsWith("Credit")) {
                    summaryData.logo = "credit-card";
                    summaryData["account-type"] = "Credit Cards";
                } else {
                    summaryData.logo = "university";
                }
            });
            return state.accountSummaryData.accountSummaryData.data;
        }
    });

    useEffect(() => {
        ensureDataFetched();
        if (ismxServiceActive || isYodleeTransactionServiceActive) {
            getMXUserStatus(false);
        }
    }, []);

    const closeTransactionEditAccountDialog = () => {
        setShowTransactionEditAccountDialog(false);
    };

    const closeTransactionSetAlertPrefDialog = () => {
        setShowTransactionAlertPrefDialog(false);
    };

    const OpenTransactionEditAccountDialog = (accountSummaryData: IAccountSummary): any => {
        setStateSummary(accountSummaryData);
        handleTransactionEditAccountDialog("show");
    };

    const OpenTransactionSetAlertPrefDialog = () => {
        handleTransactionSetAlertPrefDialog("show");
    };

    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );

    // handle edit-account dialog open/close/cancel
    const handleTransactionEditAccountDialog = (value: string): any => {
        if (value === "show") {
            setShowTransactionEditAccountDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowTransactionEditAccountDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowTransactionEditAccountDialog(false);
            requestAccountSummary();
        }
    };

    const handleTransactionSetAlertPrefDialog = (value: string): any => {
        if (value === "show") {
            setShowTransactionAlertPrefDialog(true);
        } else if (value === "cancel") {
            document.body.classList.remove("no_scroll");
            setShowTransactionAlertPrefDialog(false);
        } else if (value === "close") {
            document.body.classList.remove("no_scroll");
            setShowTransactionAlertPrefDialog(false);
        }
    };

    const showAddAccountDialog = () => {
        if (isShowAddAccountDialog || isLoadingUserStatus) return;
        getMXUserStatus(true);
    };
    const [editOptions, setEditOptions] = useState(false);
    const showEditOptions = () => {
        setEditOptions(!editOptions);
    };

    const showReconnectAccountDialog = (accountId: number) => {
        getMXReconnectAccountUrl(accountId);
    };

    const getMXReconnectAccountUrl = (accountId: number) => {
        setisShowAddAccountDialog(true);
        setDialogType("Reconnect Account");
        httpClient
            .sendRequest("GET", `api/mx/account/${accountId}/reconnect`)
            .then((data) => {
                if (data["isSuccess"] != null && data["isSuccess"] === true) {
                    setAddAccountLink(data["widgetUrl"]["url"]);
                    setAddAccountDialogIsVisible(true);
                }
                setisShowAddAccountDialog(false);
            })
            .catch(function (error) {
                setisShowAddAccountDialog(false);
                Notification({
                    type: "error",
                    title: "Reconnect Account",
                    message: "We are facing issue to reconnect account, please try again later.",
                    duration: 5,
                });
            });
    };

    const getYodleeAddAccountUrl = () => {
        setisShowAddAccountDialog(true);
        setDialogType("Add Account");
        httpClient
            .sendRequest("POST", `api/financial-account/add-account`, {})
            .then((data) => {
                if (data["status-code"] != null && data["status-code"] === "200") {
                    setAddAccountLink(data.link);
                    setAddAccountDialogIsVisible(true);
                    setisShowAddAccountDialog(false);
                    return;
                }
                setisShowAddAccountDialog(false);
            })
            .catch(function (error) {
                setisShowAddAccountDialog(false);
                Notification({
                    type: "error",
                    title: "Add Account",
                    message: "We are facing issue to add account, please try again later.",
                    duration: 5,
                });
            });
    };

    const getMXAddAccountUrl = () => {
        setisShowAddAccountDialog(true);
        setDialogType("Add Account");
        const payload = {
            disableInstitutionSearch: false,
            updateCredentials: false,
            isMobileWebview: false,
        };
        httpClient
            .sendRequest("POST", `api/mx/getUserWidgetURL`, payload)
            .then((data) => {
                if (data["isSuccess"] != null && data["isSuccess"] === true) {
                    setAddAccountLink(data["widgetUrl"]["url"]);
                    setAddAccountDialogIsVisible(true);
                }
                setisShowAddAccountDialog(false);
            })
            .catch(function (error) {
                setisShowAddAccountDialog(false);
                Notification({
                    type: "error",
                    title: "Add Account",
                    message: "We are facing issue to add account, please try again later.",
                    duration: 5,
                });
            });
    };

    const getMXUserStatus = (addAccount: boolean) => {
        setisLoadingUserStatus(true);
        httpClient
            .sendRequest("GET", `api/mx/getUserStatus`)
            .then((data) => {
                if (data["isSuccess"] != null && data["isSuccess"] === true) {
                    if (data["userStatus"] === "Activated") {
                        setisMXUserActive(true);
                        if (addAccount) {
                            if (ismxServiceActive) {
                                getMXAddAccountUrl();
                            } else if (isYodleeTransactionServiceActive) {
                                getYodleeAddAccountUrl();
                            } else {
                                console.log("service not found");
                            }
                        }
                    } else {
                        if(addAccount){
                            Notification({
                                type: "error",
                                title: "Add Account",
                                message: "Account is not yet activated, please try again!",
                                duration: 0,
                            });
                        }
                    }
                }
                setisLoadingUserStatus(false);
            })
            .catch(function (error) {
                setisMXUserActive(false);
                setisLoadingUserStatus(false);
            });
    };

    const closeAddAccountDialog = (): any => {
        document.body.classList.remove("no_scroll");
        setAddAccountDialogIsVisible(false);
        services.postTransactionMonitor().then((data) => {
            if (isMXUserActive) {
                requestMXAccountSummary();
            } else {
                requestAccountSummary();
            }
            sessionStorage.setItem('reloadUserServices', JSON.stringify(true));
            requestChartData();
            requestRecentTransactions(0, "", "", "", "", "");
        });
    };
    const editButton = (accountSumm: any) => {
        return (
            <>
                <button
                    type="button"
                    data-a11y-dialog-show="dialog-transaction-edit-account"
                    onClick={() => {
                        OpenTransactionEditAccountDialog(accountSumm);
                        window.addToDataLayer({ event: "Edit Transaction Account" });
                    }}
                    className="btn-default btn-secondary-outline btn-table btn-icon-only btn-no-border btn-no-padding btn-edit-account"
                >
                    <span className="btn-icon">
                        {" "}
                        <RenderIcons iconName="pen" />
                    </span>
                    <span className="btn-text">Edit {accountSumm["account-nickname"] || accountSumm["account-name"]}</span>
                </button>
            </>
        );
    };
    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="university" />
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Financial Accounts</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>
                                    Monitoring financial transactions is a great way to detect potential fraud early. Link your accounts here to monitor activity in
                                    one place—such as credit cards, checking & savings, and investment accounts. Then, set alert preferences to get notified when a
                                    transaction exceeds a certain limit.
                                </p>
                            </div>

                            <div className="box-description">
                                <p>
                                    <button
                                        type="button"
                                        className="btn-default btn-link btn-table"
                                        data-a11y-dialog-show="dialog-transaction-set-alert-pref"
                                        disabled={accountSummaryData == null || accountSummaryData.length < 1}
                                        title={
                                            accountSummaryData == null || accountSummaryData.length < 1
                                                ? "You need to add an account first"
                                                : "Set Alert Preferences"
                                        }
                                        onClick={() => {
                                            OpenTransactionSetAlertPrefDialog();
                                            window.addToDataLayer({ event: "Set Alert Preferences" });
                                        }}
                                    >
                                        <span className="btn-icon">
                                            <RenderIcons iconName="sliders-h" color="rgba(100,100,100,0.5) " height="25" width="25" />
                                        </span>
                                        <span className="btn-text">Set Alert Preferences</span>
                                    </button>
                                </p>
                            </div>
                        </div>
                        <div className={isShowAddAccountDialog ? "box-content loading" : "box-content"}>
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <h3 className="content-sub-title">Your Accounts</h3>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button
                                        type="button"
                                        className="btn-default btn-primary"
                                        data-a11y-dialog-show="dialog-add-account"
                                        disabled={accountSummaryData == null || accountSummaryData.length < 1}
                                        onClick={() => {
                                            showEditOptions();
                                        }}
                                    >
                                        <span className="btn-text">
                                            {!editOptions
                                                ? "Edit Accounts"
                                                : accountSummaryData == null || accountSummaryData.length < 1
                                                ? "Edit Accounts"
                                                : "Done Editing"}
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div role="grid" className={`${isLoading && "loading"}`}>
                                <div role="row">
                                    <div role="gridcell" className="data-grid has-lines row-height-md margin-top-s">
                                        {!!segData &&
                                            segData !== null &&
                                            segData.map((accountData: any) => (
                                                <div className="data-row" style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div className="col-xs-7 col-sm-12 col-no-gutter">
                                                        <div className="data-value has-gfx">
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <div style={{ display: "flex" }}>
                                                                    <span className="data-icon">
                                                                        {!!accountData["logo"] ? (
                                                                            <img className="round-img" src={accountData["logo"]} alt="Logo" />
                                                                        ) : (
                                                                            <img className="round-img" src={defaultImg} alt="Logo" />
                                                                        )}
                                                                    </span>
                                                                    <strong style={{ fontWeight: "700" }}>{accountData["memberName"]}</strong>
                                                                </div>
                                                                {editOptions && (
                                                                    <button
                                                                        type="button"
                                                                        className="btn-default btn-red-outline btn-no-border"
                                                                        data-a11y-dialog-show="dialog-transaction-delete-account"
                                                                        onClick={() => {
                                                                            handleTransactionDeleteAccountConfirmDialog("show", {
                                                                                memberName: accountData["memberName"],
                                                                                memberId: accountData["memberId"],
                                                                                isYodleeUser: isYodleeTransactionServiceActive,
                                                                            });
                                                                            window.addToDataLayer({ event: "Remove Transaction Account" });
                                                                        }}
                                                                    >
                                                                        <span className="btn-text">Delete</span>
                                                                        <span className="btn-icon">
                                                                            <em className="las la-trash-alt"></em>
                                                                        </span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="data-value has-gfx">
                                                            {accountData["accounts"].map((account: any) => (
                                                                <div style={{ padding: "5px 0", display: "flex", justifyContent: "space-between" }}>
                                                                    <div style={{ display: "flex" }}>
                                                                        <strong style={{ marginRight: "10px" }}>
                                                                            {account["account-nickname"]
                                                                                ? account["account-nickname"]
                                                                                : isYodleeTransactionServiceActive
                                                                                ? ""
                                                                                : account["account-name"]}
                                                                        </strong>
                                                                        <br />
                                                                        {!account.isDisconnected ? (
                                                                            <>
                                                                                <span className="account-type">{account["account-type"]?.replace(/_/g, " ")}</span>
                                                                                {editOptions && editButton(account)}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span className="account-alert-disconnected">
                                                                                    <em className="fa fa-exclamation-triangle"></em>
                                                                                    Disconnected
                                                                                </span>
                                                                                {editOptions && editButton(account)}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                    {!account.isDisconnected ? (
                                                                        <>
                                                                            <div className="col-xs col-no-gutter flex-grow-null">
                                                                                <span>{formatCurrency(account["account-balance"])}</span>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <div className="col-xs col-no-gutter flex-grow-null">
                                                                            <button
                                                                                type="button"
                                                                                className="btn-default btn-primary"
                                                                                data-a11y-dialog-show="dialog-add-account"
                                                                                disabled={
                                                                                    isShowAddAccountDialog ||
                                                                                    isLoadingUserStatus ||
                                                                                    (ismxServiceActive && !isMXUserActive)
                                                                                }
                                                                                onClick={() => showReconnectAccountDialog(account["account-id"])}
                                                                            >
                                                                                <span className="btn-text">Reconnect</span>
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                </div>
                                {
                                        <div 
                                            className="add-acnt"
                                            style={{ opacity: (isShowAddAccountDialog || isLoadingUserStatus) ? 0.67 : 1 }}
                                            onClick={() => {
                                                showAddAccountDialog();
                                                window.addToDataLayer({ event: "Add Financial Account" });
                                            }}
                                        >
                                        <div role="row" className="add-icon">
                                            <div role="gridcell">
                                                <em className="las la-plus"></em>
                                            </div>
                                            </div>
                                                <span className="add-text btn-text">Add Account</span>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {addAccountIsVisible && (
                <DialogComponent dialogId="dialog-add-account" title={dialogType} closeDialog={closeAddAccountDialog}>
                    <AddAccountDialog src={addAccountLink} title={dialogType} dialogId="dialog-add-account" closeDialog={closeAddAccountDialog} />
                </DialogComponent>
            )}
            {showTransactionEditAccountDialog && (
                <DialogComponent dialogId="dialog-transaction-edit-account" title="Edit Account" closeDialog={closeTransactionEditAccountDialog}>
                    <TransactionEditAccountDialog summary={stateSummary} closeDialog={handleTransactionEditAccountDialog} />
                </DialogComponent>
            )}
            {showTransactionAlertPrefDialog && (
                <DialogComponent dialogId="dialog-transaction-set-alert-pref" title="Set Alert Preference" closeDialog={closeTransactionSetAlertPrefDialog}>
                    <TransactionAlertPreferenceDialog closeDialog={handleTransactionSetAlertPrefDialog} dialogId="dialog-transaction-set-alert-pref" />
                </DialogComponent>
            )}
            {showTransactionDeleteAccountConfirmDialog && (
                <DialogComponent dialogId="dialog-transaction-delete-account" title="Delete Account" closeDialog={closeTransactionDeleteAccountConfirmDialog}>
                    <TransactionConfirmDeleteAccountDialog
                        memberInfo={deleteMemberInfo}
                        closeDialog={handleTransactionDeleteAccountConfirmDialog}
                    ></TransactionConfirmDeleteAccountDialog>
                </DialogComponent>
            )}
        </React.Fragment>
    );
}
